import { styled } from '@mui/material';

export const Styles = {
  MainContainer: styled('div')(({ theme }) => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'stretch',
    gap: '40px',
    margin: '0 auto',
    maxWidth: '1200px',
    paddingRight: '20px',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      padding: '0 15px',
      gap: '20px'
    }
  })),

  PRightContainer: styled('div')(({ theme }) => ({
    flex: '0.3',
    width: '100%',
    maxWidth: '400px',
    marginLeft: '-30px',
    [theme.breakpoints.down('md')]: {
      maxWidth: '100%',
      marginLeft: '0',
      order: 1
    }
  })),

  BannerContainer: styled('div')({
    display: 'flex',
    flexDirection: 'column',
    paddingTop: '30px'
  }),

  Main: styled('div')({
    backgroundColor: '#ebebeb'
  })
};
